import { Database } from "@copro/api";
import { DocumentMinimalData } from "../../../../types";
import { useChangeDocumentsOfResource } from "../../../documents/hooks/useChangeDocumentsOfResource";
import { usePostSubjectAction } from "../../api/usePostSubjectAction";

export default function usePostActionAndDocuments(subjectId: string) {
  const { mutateAsync: postAction, isPending: isPosting } = usePostSubjectAction();
  const { uploadPendingFiles, saveDocumentChanges, isPending: isUpdateDocumentsPending } = useChangeDocumentsOfResource();

  async function postActionAndDocuments(
    data: Database['public']['Tables']['subject_actions']['Insert'],
    documents: DocumentMinimalData[],
    providerId: string | null,
  ) {
    // Upload files first — abort before creating the action if upload fails
    const uploadedDocuments = await uploadPendingFiles(documents, { subjectId });

    const result = await postAction(data);

    const subjectActionId = result.id;

    if (result.id && uploadedDocuments.length > 0) {
      await saveDocumentChanges(
        [],
        uploadedDocuments,
        {
          subject_action_id: subjectActionId,
          sub_topic_id: subjectId,
          provider_id: providerId,
        }
      );
    }
  }

  return {
    isLoading: isPosting || isUpdateDocumentsPending,
    postActionAndDocuments
  }
}
